import { Grid, Typography } from "@mui/material";
import brand from "../brand"
import { useTranslation } from "react-i18next";

export function Home() {
  const { t } = useTranslation();
  return (
    <>
    <Grid container justifyContent="flex-start">
    <Grid item xs={12}>
    <Typography
          className="homeText"
          sx={{
            fontSize: "24px",
            fontFamily: brand.titleFont,
            fontWeight: "400",
            paddingLeft: "15px",
            paddingTop: "15px"
          }}
        >
          {t("homeText1")}
        </Typography>
  </Grid>
  
  </Grid>
  <Grid container justifyContent="flex-start">
    <Grid item xs={12}>
    <Typography
          className="homeText"
          sx={{
            fontSize: "16px",
            fontFamily: brand.bodyFont,
            fontWeight: "400",
            paddingLeft: "15px",
          }}
        >
          {t("homeText2")}
        </Typography>
  </Grid>
  </Grid>
        
      <img
        src={brand.homeImage}
        alt="homeImage"
        className="homeImage"
        
      />
    </>
  );
}
